<template>
  <div id="contentlogin" class="contentlogin">
    <section class="bienvenida">
      <img src="../assets/logotipo.png" alt="Logotipo Bool" />
      <br />
      <label>Bienvenido a Bo'ol V 1.0</label>
    </section>
    <form class="formulariologin">
      <div class="form-group" style="float:none !important;">
        <label for="email" size="15" maxlength="20" class="n5">E-mail</label>
        <input 
         type="text"
         name="email"
         id="email"
         autocomplete="false"
         v-model="email" 
        />
        <span style="color:red" v-if="errorEmail">*Ingresa un e-mail válido</span>
      </div>
      <div class="form-group">
        <label for="contrasena" minlenght="8" maxlength="20">Contraseña</label>
        <input
          type="password"
          name="password"
          id="password"
          autocomplete="false"
          v-model="password"
          @keyup.enter="validacion()"
        />
        <span style="color: red" v-if="errorPassword">*Favor de ingresar contraseña</span>
        <br v-if="espacio" />
        <br v-if="espacio" />
      </div>
      <div class="form-group text-center">
        <button
          type="button"
          class="boton mt-2"
          style="float:none !important;"
          id="ingresar"
          @click="validacion()"
        >Ingresar</button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      errorEmail: false,
      errorPassword: false,
      email: "",
      password: "",
      espacio: true,
      errors: []
    };
  },
  methods: {
    validacion: function() {
      this.validarEmail();
      //console.log("Termino validacion de email");
      this.validarPassword();
      //console.log("Termino validacion de password");
      if (this.errors.length == 0) {
        this.errors = [];
        return this.identidad();
      } else {
        this.errors = [];
      }
    },
    identidad() {
      /*Api para email y contraseña*/
      //console.log("Llegue");
      this.$router.push("/terms");
    },
    //Valida expresion regular de email
    validarEmail() {
      //console.log("entro a Validar Email");
      var exp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (exp.test(this.email)) {
        this.espacio = false;
        this.errorEmail = false;
        //console.log("El correo esta bien");
        return false;
      } else {
        this.errorEmail = true;
        this.espacio = false;
        this.errors.push("Email inválido");
        //console.log("El correo no esta bien");
        return true;
      }
    },
    /*Valida expresion regular de password 
        La contraseña debe tener al entre 8 y 16 caracteres, al menos un dígito, 
        al menos una minúscula y al menos una mayúscula.NO puede tener otros símbolos*/
    validarPassword() {
      //console.log("entro a Validar Password");
      var exp = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      if (exp.test(this.password)) {
        this.errorPassword = false;
        //console.log("El password esta bien");
        return false;
      } else {
        this.espacio = false;
        this.errorPassword = true;
        this.errors.push("Password inválido");
        //console.log("El password no cumple la expresion");
        return true;
      }
    }
  },
  computed: {
    ValidarEmail() {
      //console.log("entro a Validar Email");
      var exp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (exp.test(this.email)) {
        this.errorEmail = false;
        return false;
      } else {
        this.espacio = false;
        this.errorEmail = true;
        return true;
      }
    }
  }
};
</script>